import clsx from 'clsx'
import { CSSProperties, ReactNode } from 'react'

type ExtendedCSSProperties = CSSProperties & {
  [key: `--${string}`]: string | number | undefined
}

type TileProps = {
  icon: ReactNode
  title: string
  copy: string | ReactNode
  className?: string
  style?: ExtendedCSSProperties
}

export const Tile = ({ icon, title, copy, className, style }: TileProps) => {
  return (
    <div className={clsx('tile', className)} style={style}>
      <div className="tile-icon">{icon}</div>
      <div className="tile-content">
        <h3 className="tile-title">{title}</h3>
        <p className="tile-copy">{copy}</p>
      </div>
    </div>
  )
}
